// assets
import {
    IconRulerMeasure2, IconCalendarHeart, IconCalendarTime, IconCalendarMinus, IconCalendarDollar, IconCalendarX,
    IconClockHour9, IconDeviceWatchShare, IconStethoscope, IconChartPie, IconPlus, IconScale,
    IconCalendarUser, IconUserPause, IconCalendar, IconQuestionMark, IconUserExclamation, IconCalendarCheck
} from '@tabler/icons-react';

// constant
const icons = {
    IconRulerMeasure2,
    IconCalendarHeart,
    IconCalendarTime,
    IconCalendarMinus,
    IconCalendarDollar,
    IconCalendarX,
    IconClockHour9,
    IconDeviceWatchShare,
    IconStethoscope,
    IconChartPie,
    IconPlus,
    IconCalendarUser,
    IconScale,
    IconUserPause,
    IconCalendar,
    IconQuestionMark,
    IconUserExclamation,
    IconCalendarCheck
};

const userRole = localStorage.getItem('userRole');
const IsEmployee = userRole === 'EMPLOYEE';
const IsDev = userRole === 'DEV';

// ==============================|| LEAVES MENU ITEMS ||============================== //

export const manageLeaveSection = {
    id: 'leaves',
    title: IsDev ? 'Attendance Managment Section' : 'Attendance',
    type: 'group',
    children: [
        {
            id: 'vacation',
            title: 'Vacation',
            type: 'item',
            url: '/vacation',
            icon: icons.IconCalendarUser,
            breadcrumbs: false
        },
        {
            id: 'absence',
            title: 'Absence',
            type: 'collapse',
            icon: icons.IconUserExclamation,
            children: [
                {
                    id: 'lateness',
                    title: 'Lateness',
                    type: 'item',
                    url: '/lateness',
                    icon: icons.IconClockHour9,
                    breadcrumbs: false
                },
                {
                    id: 'sickness',
                    title: 'Sickness',
                    type: 'item',
                    url: '/sickness',
                    icon: icons.IconStethoscope,
                    breadcrumbs: false
                },
                {
                    id: 'Personal Commitment',
                    title: 'Personal Commitment',
                    type: 'item',
                    url: '/personal',
                    icon: icons.IconDeviceWatchShare,
                    breadcrumbs: false
                },
                /* {
                 id: 'Suspension',
                 title: 'Suspension',
                 type: 'item',
                 url: '/suspension',
                 icon: icons.IconUserPause,
                 breadcrumbs: false
               }, */
                {
                    id: 'day_off',
                    title: 'Day Off',
                    type: 'item',
                    url: '/day_off',
                    icon: icons.IconCalendar,
                    breadcrumbs: false
                },
                {
                    id: 'unknown',
                    title: 'Unknown',
                    type: 'item',
                    url: '/unknown',
                    icon: icons.IconQuestionMark,
                    breadcrumbs: false
                },
            ]
        },
        {
            id: 'overtime-management',
            title: 'Overtime Management',
            type: 'item',
            url: '/overtime-management',
            icon: icons.IconClockHour9,
            breadcrumbs: false
        },
        // {
        //     id: 'kpi',
        //     title: 'Attendance Indicators',
        //     type: 'item',
        //     url: '/kpi',
        //     icon: icons.IconChartPie,
        //     breadcrumbs: false
        // },
        // {
        //     id: 'holiday-correction',
        //     title: 'Holiday Correction',
        //     type: 'item',
        //     url: '/holiday-correction',
        //     icon: icons.IconCalendarCheck,
        //     breadcrumbs: false
        // },
    ]
}


export const employeeLeaveSection = {
    id: 'leaves',
    title: IsDev ? 'Employee Attendance Section' : 'Attendance',
    type: 'group',
    children: [
        {
            id: 'absence',
            title: (!IsEmployee && !IsDev) ? 'Absences Management' : 'My Absences',
            type: 'item',
            url: '/absence',
            icon: icons.IconCalendarX,
            breadcrumbs: false
        },
        {
            id: 'leaves',
            title: (!IsEmployee && !IsDev) ? 'Leaves Management' : 'My Leaves',
            type: 'item',
            url: '/leaves',
            icon: icons.IconCalendarTime,
            breadcrumbs: false
        },
        {
            id: 'my-overtime',
            title: (!IsEmployee && !IsDev) ? 'Overtime Management' : 'My Overtime',
            type: 'item',
            url: '/my-overtime',
            icon: icons.IconClockHour9,
            breadcrumbs: false
        },
        {
            id: 'leaves-rules',
            title: (!IsEmployee && !IsDev) ? 'Rules Management' : 'My balance',
            type: 'item',
            url: '/my-balance',
            icon: icons.IconRulerMeasure2,
            breadcrumbs: false
        },

    ]
}

export const personalLeaveSection = {
    id: 'personal-leaves',
    title: 'Personal Portal',
    type: 'group',
    children: [
        {
            id: 'my-absence',
            title: 'My Absences',
            type: 'item',
            url: '/absence?personal=true',
            icon: icons.IconCalendarX,
            breadcrumbs: false
        },
        {
            id: 'my-leaves',
            title: 'My Leaves',
            type: 'item',
            url: '/leaves?personal=true',
            icon: icons.IconCalendarTime,
            breadcrumbs: false
        },
        {
            id: 'my-overtime-personal',
            title: 'My Overtime',
            type: 'item',
            url: '/my-overtime',
            icon: icons.IconClockHour9,
            breadcrumbs: false
        }
    ]
};

let defaultOther;
if (userRole === 'EMPLOYEE') {
    defaultOther = employeeLeaveSection;
} else if (['MANAGER', 'HR', 'DIRECTOR'].includes(userRole)) {
    defaultOther = manageLeaveSection;
} else {
    // For unknown roles, return empty group
    defaultOther = { id: 'other', title: 'Other', type: 'group', children: [] };
}

export default defaultOther;
